// Utilities
import debounce from '../../js/modules/debounce'
import ismobileviewport from '../../js/modules/mt-ismobileviewport.js'

export default function () {
  $(document).ready(function () {
    $('.accordion').on('click', '.accordion__title', function (e) {
      // dont let clicks reach parent accordions
      e.stopPropagation()
        // if the accordion is mobile only then don't react to clicks
      if ($(this).closest('.accordion').hasClass('accordion--mobm')) {
        if (!ismobileviewport()) {
          return false
        }
      }

      // open and close accordions
      // Simple toggle logic relies on good HTML structure and starting state
      // if this becomes problematic, replace with verbose if-open-then-close and if-closed-then-open-logic
      if ($(this).closest('.accordion').hasClass('accordion--is-open')) {
        // close accordion
        $(this).closest('.accordion').removeClass('accordion--is-open').addClass('accordion--is-closed')
        $(this).next('.accordion__content').slideUp('fast')
      } else {
        // open accordion
        $(this).closest('.accordion').addClass('accordion--is-open').removeClass('accordion--is-closed')
        $(this).next('.accordion__content').slideDown('fast')
      }
    })

    // ToDo: if the viewport size changes, if filters have been closed then open them again.

    // var checkIfDesktopOpenaccordions = debounce(function () {
    //   requestAnimationFrame(function () {
    //     // All the taxing stuff you do
    //     if (!ismobileviewport()) {
    //       // if on desktop open accordions
    //       // these next lines work on a desktop pretending to be a mobile but on iOS when you scroll the window resizes and triggers resize events in turn $('.accordion').addClass('accordion--is-open').removeClass('accordion--is-closed')
    //       // these next lines work on a desktop pretending to be a mobile but on iOS when you scroll the window resizes and triggers resize events in turn $('.accordion__content').show()
    //     } else {
    //       // if on mobile close accordions
    //       // $('.accordion').removeClass('accordion--is-open').addClass('accordion--is-closed')
    //       // $('.accordion__content').hide()
    //     }
    //   }, 250)
    // })

    // window.addEventListener('resize', checkIfDesktopOpenaccordions)
  })
}
